import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const AFFILIATE_BANNER_QUERY = 'affiliate.banner-view';
export const AFFILIATE_BANNER_API_URL = 'affiliate/banners';

export const AFFILIATE_BANNER_PERMISSIONS = {
  SHOW: new Permission(undefined, PermissionsList.affiliate.BANNERS_LIST),
};
